// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_pfL","fullView":"styles_fullView__1bcxo"};